import { BehaviorSubject, Observable, Subject, from, throwError } from 'rxjs';
import { map, catchError, tap, switchMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AuthService } from 'ngx-auth';

import { TokenStorage } from './token-storage.service';
import { UtilsService } from '../services/utils.service';
import { CredentialService } from '../services/credential.service';
import { AccessData } from './access-data';
import { Credential } from './credential';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class AuthenticationService implements AuthService {
	API_URL = 'https://app.skyversa.com:4441/api';
	API_ENDPOINT_LOGIN = '/login';
	API_ENDPOINT_REFRESH = '/refresh';
	API_ENDPOINT_REGISTER = '/register';

	constructor(
		private http: HttpClient,
		private tokenStorage: TokenStorage,
		private util: UtilsService,
		private credservice: CredentialService,
		private permissionsService: NgxPermissionsService
	) {
		
	
	}

	/**
	 * Check, if user already authorized.
	 * @description Should return Observable with true or false values
	 * @returns {Observable<boolean>}
	 * @memberOf AuthService
	 */
	public isAuthorized(): Observable<boolean> {
		return this.tokenStorage.getAccessToken().pipe(map(token => !!token));
	}

	/**
	 * Get access token
	 * @description Should return access token in Observable from e.g. localStorage
	 * @returns {Observable<string>}
	 */
	public getAccessToken(): Observable<string> {
		return this.tokenStorage.getAccessToken();
	}

	/**
	 * Get user roles
	 * @returns {Observable<any>}
	 */
	public getUserRoles(): Observable<any> {
		console.log(this.tokenStorage.getUserRoles());
		return this.tokenStorage.getUserRoles();
	}

	/**
	 * Function, that should perform refresh token verifyTokenRequest
	 * @description Should be successfully completed so interceptor
	 * can execute pending requests or retry original one
	 * @returns {Observable<any>}
	 */
	public refreshToken(): Observable<AccessData> {
		return this.tokenStorage.getRefreshToken().pipe(
			switchMap((refreshToken: string) => {
				return this.http.get<AccessData>(this.API_URL + this.API_ENDPOINT_REFRESH + '?' + this.util.urlParam(refreshToken));
			}),
			// tap(this.saveAccessData.bind(this)),
			catchError(err => {
				this.logout();
				return throwError(err);
			})
		);
	}

	/**
	 * Function, checks response of failed request to determine,
	 * whether token be refreshed or not.
	 * @description Essentialy checks status
	 * @param {Response} response
	 * @returns {boolean}
	 */
	public refreshShouldHappen(response: HttpErrorResponse): boolean {
		return response.status === 401;
	}

	/**
	 * Verify that outgoing request is refresh-token,
	 * so interceptor won't intercept this request
	 * @param {string} url
	 * @returns {boolean}
	 */
	public verifyTokenRequest(url: string): boolean {
		return url.endsWith(this.API_ENDPOINT_REFRESH);
	}


	public LoginOk(credential:any): Observable<any> {
		return this.http.post<any>(this.API_URL + this.API_ENDPOINT_LOGIN , credential).pipe(
			switchMap((result: any) => {
				console.log('**************->');
				console.log(result);
				let token ="";
				if (typeof result !== 'undefined' && result.user == true) {
					console.log(true);
					token = result.token;
					console.log(token);
					let headers = {headers:{'Authorization': 'Bearer '+ result.token }};
					console.log(headers);
					return this.http.get<any>(this.API_URL + '/generalnfo',headers).pipe(
						switchMap((data: any) => {
							console.log(token)
							this.saveTokentoLocal(token);
							this.tokenStorage.setUserRoles(['SUBSCRIBER']);
							this.tokenStorage.setUserData(data.data);
							this.credservice.setCurrrentUserRoles(['SUBSCRIBER']);
							this.credservice.setUserData(data.data);
							// this.permissionsService.addPermission(['SUBSCRIBER']);
							return [{error:false,user:true}]; 
							
						})
					);
				}else{
					console.log(false);
					return [{error:true,user:false}]
				}
			
			}),
			catchError(this.handleError('login', [{user:false,error:true}]))
		);
	}


	public saveTokentoLocal(data:any): Observable<any> {
		console.log(data);
		return	this.tokenStorage.saveTokenData(data);
		
	}

	



	/**
	 * Handle Http operation that failed.
	 * Let the app continue.
	 * @param operation - name of the operation that failed
	 * @param result - optional value to return as the observable result
	 */
	private handleError<T>(operation = 'operation', result?: any) {
		return (error: any): Observable<any> => {
			console.log(operation);
			console.log (error);
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead
			
			// Let the app keep running by returning an empty result.
			let errorMessage =[];
			errorMessage.push({error:true,user:false,message:error.message,status:error.status})
			return from(errorMessage);
		};
	}

	/**
	 * Logout
	 */
	public logout(refresh?: boolean): void {
		this.tokenStorage.clear();
		if (refresh) {
			location.reload(true);
		}
	}


	/**
	 * Submit registration request
	 * @param {Credential} credential
	 * @returns {Observable<any>}
	 */
	public register(credential: Credential): Observable<any> {
		console.log('register');
		// dummy token creation
		credential = Object.assign({}, credential, {
			accessToken: 'access-token-' + Math.random(),
			refreshToken: 'access-token-' + Math.random(),
			roles: ['USER'],
		});
		return this.http.post(this.API_URL + this.API_ENDPOINT_REGISTER, credential)
			.pipe(catchError(this.handleError('register', []))
		);
	}

	/**
	 * Submit forgot password request
	 * @param {Credential} credential
	 * @returns {Observable<any>}
	 */
	public requestPassword(credential: Credential): Observable<any> {
		return this.http.get(this.API_URL + this.API_ENDPOINT_LOGIN + '?' + this.util.urlParam(credential))
			.pipe(catchError(this.handleError('forgot-password', []))
		);
	}

	post(credentials:any){
		console.log(this.API_URL+this.API_ENDPOINT_LOGIN)
		return this.http.post(this.API_URL+this.API_ENDPOINT_LOGIN, credentials);
	}

}
